import { ServerResponse, UserCredentials } from '../models';

export class ServerResponseConverter<T> {
    public GetResult(originalResponse: string): T[] {
        const response: ServerResponse<T> = JSON.parse(originalResponse);
        const result: T[] = response.Result.Resultset;

        return result;
    }

    public GetCount(x: string): number {
        const response: ServerResponse<T> = JSON.parse(x);
        const result = response.Result.ReturnCode;

        return result;
    }

    public GetUser(userData): UserCredentials {
        const response: ServerResponse<null> = typeof (userData) === 'object' ? userData : JSON.parse(userData);
        const result = new UserCredentials();
        result.EMail = response.Result.EMail;
        result.Id_Session = response.Result.Id_Session;
        result.Id_User = response.Result.Id_User;
        result.Region = response.Result.Region;
        result.Sex = response.Result.Sex;

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/converters/server-response-converter.ts